import * as React from "react";

import { connect } from "react-redux";
import { Button, Col } from "reactstrap";
import { RootState } from "../../store";
import {
  ApplicationAction,
    setAmount,
    setAmountOther,
    setRepaymentPeriod,
    setStartAmount
} from "../../store/application/applicationActions";
import ApplicationContent from "../applicationContent";
import { trackEvent } from "../../util/gtm";

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

interface State {
  options: { text: string; value: number }[];
  optionsReverse: { text: string; value: number }[];
}

class StepOne extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
        options: [
        
        {
          text: "10.000 kr.",
          value: 10_000
        },
        {
          text: "15.000 kr.",
          value: 15000
        },
        {
          text: "20.000 kr.",
          value: 20000
        },
        {
          text: "25.000 kr.",
          value: 25000
        },
        {
          text: "40.000 kr.",
          value: 40000
        },
        {
          text: "50.000 kr.",
          value: 50000
            },
        //{
        //    text: "60.000 kr.",
        //    value: 60000
        //},
        //{
        //    text: "75.000 kr.",
        //    value: 75000
        //},
             {
          text: "Andet...",
          value: 50000
        }
        ],
          optionsReverse: [
            {
              text: "150.000 kr.",
              value: 150000
            },
            {
                text: "100.000 kr.",
                value: 100000
            },
            {
                text: "75.000 kr.",
                value: 75000
            },
            {
                text: "50.000 kr.",
                value: 50000
            },
            {
                text: "40.000 kr.",
                value: 40000
            },
            {
                text: "30.000 kr.",
                value: 30000
            },
            {
                text: "20.000 kr.",
                value: 20000
            },
            {
                text: "10.000 kr.",
                value: 10_000
            },
          
        ]
      };
      
    }

    ga(tracker):void {
        var clientId = tracker.get('clientId');
    };

    render() {
        var stepQuery = window.location.protocol + "//" + window.location.host + window.location.pathname + window.location.search;
        window.history.pushState({ path: stepQuery }, '', stepQuery)
    return (
        <ApplicationContent>
            <h2 className="header-margin">Hvor meget vil du låne?</h2>
        {/* <div className="container-fluid"> */}
        <div className="row">
                {this.state.optionsReverse.map((optionsReverse, index) => (
            <Col
              key={index}
              className={
                  "col-6 col-sm-4 py-2 px-2 " + "col-amount-" + optionsReverse.value
              }
                    >  
                  <Button
                      className="loanbtn"
                            onClick={() => {
                                this.props.setAmount(optionsReverse.value);
                                if (optionsReverse.text == "Andet...") {
                                    this.props.setStartAmount(0)
                                }
                                else {
                                    this.props.setStartAmount(optionsReverse.value)
                                }
                              
                          trackEvent(
                              "Forside låne mængde",
                              optionsReverse.text,
                              "Beløb knapper på forsiden",
                              optionsReverse.value
                          )
                      }
                      }
              >
                            {optionsReverse.text}
              </Button>
            </Col>
                ))}
                <Col
                    className={
                        "col-6 col-sm-4 py-2 px-2 " + "col-amount-" + 50000
                    }
                >
                    <Button
                        className="loanbtn"
                        onClick={() => {
                            this.props.setAmountOther(50000);
                                this.props.setStartAmount(0)

                          
                        }
                        }
                    >
                        {"Andet..."}
                    </Button>
                </Col>
        </div>
        {/* </div> */}
      </ApplicationContent>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  application: state.applicationState
});

const mapDispatchToProps = (dispatch: (action: ApplicationAction) => void) => ({
  setAmount: (amount: number) => dispatch(setAmount(amount)),
    setAmountOther: (amount: number) => dispatch(setAmountOther(amount)),
    setStartAmount: (amount: number) => dispatch(setStartAmount(amount)),
    setRepaymentPeriod: (months: number) => dispatch(setRepaymentPeriod(months)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StepOne);
